import {Component, OnDestroy, OnInit} from "@angular/core";
import {AppSettingsService} from "./app-settings/app-settings.service";
import {DialogService} from "./bootstrap-modal/dialog.service";
import {SupportComponent} from "./support/support.component";
import {WorkflowTrackingReportComponent} from "./workflow/dialog-workflow-tracking-report.component";
import {AppAlertService} from "./app-alert/app-alert.service";
import {InterTabCommunicatorService} from "./app-settings/inter-tab-communicator.service";
import {Subscription} from "rxjs";
import {LoginService} from "./login/login.service";
import {NotificationsService} from "./notifications/notifications.service";

@Component({
  selector: "transition-tool",
  templateUrl: "./transition-tool.template.pug",
})
export class TransitionToolComponent implements OnInit, OnDestroy {
  alertCount: number = 0;
  navigationVisible: boolean = false;
  private navigationVisibleSubscription: Subscription;
  private userSubscription: Subscription;

  hidden: boolean = true;

  constructor(
    public appSettingsService: AppSettingsService,
    private dialogService: DialogService,
    private appAlertService: AppAlertService,
    private interTabCommunicatorService: InterTabCommunicatorService,
    private loginService: LoginService,
    private notificationsService: NotificationsService,
  ) {
    this.appAlertService.alerts.subscribe((alerts) => { this.alertCount = alerts.length; });
    this.loginService.init();
    this.notificationsService.init();
  }

  ngOnInit() {
    this.userSubscription = this.appSettingsService.user.subscribe((user) => {
      this.hidden = !user || !user.id;
    });

    this.navigationVisibleSubscription = this.interTabCommunicatorService.observe("navigationVisible")
      .subscribe((value) => {
        this.navigationVisible = !!value;
      });

    this.appSettingsService.load()
      .catch((error) => {
        console.error(error);
      });
  }

  ngOnDestroy() {
    if (this.navigationVisibleSubscription && !this.navigationVisibleSubscription.closed) {
      this.navigationVisibleSubscription.unsubscribe();
    }

    if (this.userSubscription && !this.userSubscription.closed) {
      this.userSubscription.unsubscribe();
    }
  }

  showSupportModal() {
    SupportComponent.showSupportModal(this.dialogService);
    this.navItemClicked();
  }

  showWorkflowReportModal() {
    WorkflowTrackingReportComponent.showWorkflowTrackingReportModal(this.dialogService, null);
  }

  stop(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    return false;
  }

  swipeOpenSideNav(event) {
    if (!event || !event.pointers || !event.pointers[0]) return;
    const left = event.pointers[0].pageX - event.distance;
    if (left > 10) return;
    this.showNavigation();
  }

  swipeClosedSideNav(event) {
    if (!event) return;

    const width = window.innerWidth || 200;
    if (event.distance < width * 0.25) return;

    this.hideNavigation();
  }

  navItemClicked() {
    if (window.innerWidth < 768) {
      this.hideNavigation();
    }
  }

  toggleNavigation() {
    this.navigationVisible = !this.navigationVisible;
    this.interTabCommunicatorService.send("navigationVisible", this.navigationVisible);
  }

  showNavigation() {
    this.navigationVisible = true;
    this.interTabCommunicatorService.send("navigationVisible", this.navigationVisible);
  }

  hideNavigation() {
    this.navigationVisible = false;
    this.interTabCommunicatorService.send("navigationVisible", this.navigationVisible);
  }
}
